export class FirebaseConstants {
    public static EX_MESSAGES_NODE = '/External_Messages/'; // collection name which stores external chat messages
    public static IN_MESSAGES_NODE = '/Internal_Messages/'; // collection name which stores external chat messages
    public static FILE_TYPES = '/File_Types/'; // file type ids and names
}


// WEBPACK FOOTER //
// ./src/app/core/firebase/firebase-constants.ts